export class ValidationFeedback {
  public static negativeInteger = 'Please enter a non-negative integer.';
  public static negativeNumber = 'Please enter a non-negative number with up to 2 decimal places.';
  public static invalidForm = 'One or more input fields are not valid. Please use the feedback to check your input.';
}
